// extracted by mini-css-extract-plugin
export default {"languageTitle":"hud_languageTitle__4JTGf"};